import React, { useEffect, useRef, useState } from "react";
import Footer from "../../Components/Footer";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import moment from "moment";
import PagesHeader from "../../Components/PagesHeader";
import { ApiService } from "../../Components/Services/apiservices";
let apiServices = new ApiService();
function Contact() {
  const didMountRef = useRef(true);
  const { slug } = useParams();
  const [pageData, setPageData] = useState({});
  const [headerImage, setHeaderImage] = useState("");
  const [partnerData, setPartnerData] = useState([]);
  const [partnerImageUrl, setPartnerImageUrl] = useState("");
  const [defaultImage, setDefaultImage] = useState("");
  const [settingData, setSettingData] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [defaltImage, setDefaltImage] = useState("");
  const [Email, setEmail] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Name, setName] = useState("");
  const [Subject, setSubject] = useState("");
  const [Message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessmessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (didMountRef.current) {
      const dataString = {
        page_url: "contact",
      };
      apiServices.pagePostRequest(dataString).then((res) => {
        if (res.data.status === "success") {
          if (res.data.pageData != null) {
            setPageData(res.data.pageData);
            setHeaderImage(res.data.page_header_url);
          }
        }
      });

      apiServices.newspartnerUrlGetRequest().then((res) => {
        if (res.data.status === "success") {
          setPartnerData(res.data.partnerData);
          setPartnerImageUrl(res.data.partner_url);
          setDefaultImage(res.data.default_image_baseurl);
        }
      });

      apiServices.settingsdataGetRequest().then((res) => {
        if (res.data.status == "success") {
          setImageUrl(res.data.settings_url);
          setSettingData(res.data.sitesettings);
          setDefaltImage(res.data.default_image_baseurl);
        }
      });
    }

    didMountRef.current = false;
  }, []);
  //   const submitmessage = (e) => {
  //     e.preventDefault()
  //     if (Name == "") {
  //         document.getElementById("contact-name").style.border = "1px solid red"
  //         return false
  //     }
  //     else if (Email == "") {
  //         document.getElementById("contact-email").style.border = "1px solid red"
  //         return false
  //     }
  //     else if (Mobile == "") {
  //         document.getElementById("contact-phone").style.border = "1px solid red"
  //         return false
  //     }
  //     else if (Subject == "") {
  //         document.getElementById("contact-subject").style.border = "1px solid red"
  //         return false
  //     }
  //     else if (Message == "") {
  //         document.getElementById("contact-message").style.border = "1px solid red"
  //         return false
  //     }
  //     else {

  //         setName("")
  //         setEmail("")
  //         setMobile("")
  //         setSubject("")
  //         setMessage("")
  //         document.getElementById("contact-name").style.border = "1px solid var()"
  //         document.getElementById("contact-email").style.border = "1px solid var()"
  //         document.getElementById("contact-phone").style.border = "1px solid var()"
  //         document.getElementById("contact-subject").style.border = "1px solid var()"
  //         document.getElementById("contact-message").style.border = "1px solid var()"

  //         const dataString = {
  //             "contact_name": Name,
  //             "contact_email": Email,
  //             "contact_mobile": Mobile,
  //             "contact_subject": Subject,
  //             "contact_message": Message,
  //         }

  //         apiServices.contactusprocessPostRequest(dataString).then(res => {
  //             console.log(res);
  //             if (res.data.status === "success") {
  //                 setSuccessmessage(res.data.message);
  //                 setTimeout(() => {
  //                     window.location.href = '/thank-you';
  //                 }, 2000);
  //             } else if (res.data.status === "error") {
  //                 setErrorMessage(res.data.message);
  //             }

  //         });

  //     }
  // }

  const submitmessage = (e) => {
    e.preventDefault();

    if (Name == "") {
      document.getElementById("contact-name").style.border = "1px solid red";
      return false;
    } else if (Email == "") {
      document.getElementById("contact-email").style.border = "1px solid red";
      return false;
    } else if (Mobile == "") {
      document.getElementById("contact-phone").style.border = "1px solid red";
      return false;
    } else if (Subject == "") {
      document.getElementById("contact-subject").style.border = "1px solid red";
      return false;
    } else if (Message == "") {
      document.getElementById("contact-message").style.border = "1px solid red";
      return false;
    } else {
      setLoading(true); // ✅ START LOADING

      const dataString = {
        contact_name: Name,
        contact_email: Email,
        contact_mobile: Mobile,
        contact_subject: Subject,
        contact_message: Message,
      };

      apiServices
        .contactusprocessPostRequest(dataString)
        .then((res) => {
          console.log(res);

          if (res.data.status === "success") {
            setSuccessmessage(res.data.message);

            // ✅ clear form AFTER success
            setName("");
            setEmail("");
            setMobile("");
            setSubject("");
            setMessage("");

            // reset borders
            document.getElementById("contact-name").style.border = "";
            document.getElementById("contact-email").style.border = "";
            document.getElementById("contact-phone").style.border = "";
            document.getElementById("contact-subject").style.border = "";
            document.getElementById("contact-message").style.border = "";

            setTimeout(() => {
              window.location.href = "/thank-you";
            }, 2000);
          } else {
            setErrorMessage(res.data.message);
          }
        })
        .catch(() => {
          setErrorMessage("Something went wrong!");
        })
        .finally(() => {
          setLoading(false); // ✅ STOP LOADING
        });
    }
  };

  return (
    <>
      <PagesHeader />
      <style>
        {`
          .contact-banner-responsive {
              background-image: url('/assets/img/food/Contact-Desktop-Banner.webp');
          }
          @media (max-width: 768px) {
              .contact-banner-responsive {
                  background-image: url('/assets/img/food/Contact-Mobile-Banner.webp');
              }
          }
      `}
      </style>
      <div id="cappa-main">
        <div
          className="banner-header section-padding bg-position-bottom valign bg-img bg-fixed contact-banner-responsive"
          data-overlay-dark="3"
          style={{
            backgroundSize: "cover",
            backgroundPosition: "100%",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center caption mt-90">
                <h5></h5>
                <h1 dangerouslySetInnerHTML={{ __html: pageData?.metadata?.page_title || 'Contact Us' }} />
              </div>
            </div>
          </div>
        </div>
        <section className="contact section-padding">
          <div className="container">
            <div className="row mb-90">
              <div className="col-md-6 mb-60">
                <h3>
                  <b>Chokhi Dhani</b>
                </h3>
                <p>
                  {pageData?.metadata?.contact_desc || 'Get in touch with us to reserve a table or for any inquiries regarding corporate events, social gatherings, and more.'}
                </p>
                {/* <p>Hotel ut nisl quam nestibulum ac quam nec odio elementum sceisue the aucan ligula. Orci varius natoque penatibus et magnis dis parturient monte nascete ridiculus mus nellentesque habitant morbine.</p> */}
                <div className="reservations mb-30">
                  <div className="icon">
                    <span className="flaticon-call"></span>
                  </div>
                  <div className="text">
                    <p>Reservations</p>
                    <a
                      href={"tel:" + settingData.admin_support_mobile}
                      className="footer-contact-phone"
                    >
                      {settingData.admin_support_mobile}
                    </a>
                    <br />
                    <a
                      href={"tel:" + settingData.admin_mobile}
                      className="footer-contact-phone"
                    >
                      {settingData.admin_mobile}
                    </a>
                  </div>
                </div>
                <div className="reservations mb-30">
                  <div className="icon">
                    <span className="flaticon-envelope"></span>
                  </div>
                  <div className="text">
                    <p>Email Info</p>
                    <a href={"mailto:" + settingData.admin_email}>
                      {settingData.admin_email}
                    </a>
                  </div>
                </div>
                <div className="reservations mb-30">
                  <div className="icon">
                    <span className="flaticon-location-pin"></span>
                  </div>
                  <div className="text">
                    <p>Address</p>
                    <a
                      href="https://goo.gl/maps/U4in9GLkcYvvayJn8"
                      target="new"
                    >
                      {settingData.address}
                      <br />
                    </a>
                  </div>
                </div>
                <div>
                  <h3>
                    <b>Travel Notes</b>
                  </h3>
                  <p>
                    {settingData?.travel_notes || pageData?.metadata?.travel_notes || 'The nearest tube station is Vauxhall (Victoria Line) / Battersea Power Station (Northern Line). From Vauxhall Station (Stop E), you can either get a 156/344/436 bus. Alternatively, you could walk to the venue. A walking distance of 15 minutes along the river from Vauxhall Station and a 5 minutes\' walk from Battersea Power Station.'}
                  </p>
                </div>
              </div>
              <div className="col-md-5 mb-30 offset-md-1">
                <div className="booking-box" style={{ marginBottom: 0 }}>
                  <div className="head-box">
                  </div>
                  <div
                    className="booking-inner clearfix"
                    id="showbookingboxcontact01"
                  ></div>
                  <div
                    id="showbookingboxcontact"
                    className="mcbooking"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center mb-60">
              <div className="col-lg-8 col-md-10 text-center">
                <h3>
                  <b>Get in touch</b>
                </h3>
                {successMessage != "" ? (
                  <div className="alert alert-success" role="alert">
                    {successMessage}
                  </div>
                ) : (
                  ""
                )}
                {errorMessage != "" ? (
                  <div className="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                ) : (
                  ""
                )}

                <form method="post" className="contact__form text-start">
                  <div className="row">
                    <div className="col-md-6 form-group mb-3">
                      <input
                        name="contact-name"
                        id="contact-name"
                        type="text"
                        placeholder="Your Name *"
                        onChange={(e) => setName(e.target.value)}
                        value={Name}
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <input
                        name="contact-email"
                        id="contact-email"
                        type="email"
                        placeholder="Your Email *"
                        onChange={(e) => setEmail(e.target.value)}
                        value={Email}
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <input
                        name="contact-phone"
                        id="contact-phone"
                        type="number"
                        placeholder="Your Number *"
                        onChange={(e) => setMobile(e.target.value)}
                        value={Mobile}
                        required
                        style={{ color: "#666" }}
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <input
                        name="contact-subject"
                        id="contact-subject"
                        type="text"
                        placeholder="Subject *"
                        onChange={(e) => setSubject(e.target.value)}
                        value={Subject}
                        required
                      />
                    </div>
                    <div className="col-md-12 form-group mb-3">
                      <textarea
                        name="contact-message"
                        id="contact-message"
                        cols="30"
                        rows="4"
                        placeholder="Message *"
                        onChange={(e) => setMessage(e.target.value)}
                        value={Message}
                        required
                      ></textarea>
                    </div>

                    <div className="col-md-12 text-center">
                      <button
                        type="submit"
                        className="butn-dark2"
                        name="submit"
                        onClick={submitmessage}
                        disabled={loading}
                      >
                        <span>
                          {loading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Sending...
                            </>
                          ) : (
                            "Send Message"
                          )}
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="row">
              <div
                className="col-md-12 map animate-box"
                data-animate-effect="fadeInUp"
              >
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.691480713622!2d-0.13951412426024903!3d51.48217711254672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604fce8206467%3A0x6801d6ed861bf425!2sChokhi%20Dhani!5e0!3m2!1sen!2sin!4v1681897927270!5m2!1sen!2sin"
                  width={"100%"}
                  height={"600"}
                  style={{ border: "0" }}
                  allowFullScreen=""
                  loading={"lazy"}
                ></iframe>
              </div>
              {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.691480713622!2d-0.13951412426024903!3d51.48217711254672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604fce8206467%3A0x6801d6ed861bf425!2sChokhi%20Dhani!5e0!3m2!1sen!2sin!4v1681897927270!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
            </div>
          </div>
        </section>


      </div>

      <Footer />
    </>
  );
}

export default Contact;
